<template>
    <div class="text-tooltip">
        <el-tooltip
            effect="dark"
            :disabled="hiddenTooltip"
            :content="content"
            :placement="placement"
            :open-delay="300"
            popper-class="tooltip-popper-300">
            <p class="over-flow" :class="className" @mouseover="onMouseOver(id)">
                <span :ref="id">{{ content||placeholder }}</span>
            </p>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    name: 'DsTooltip',
    componentName: 'DsTooltip',
    props: {
        // 显示的文字内容
        content: {
            type: String,
            default: () => {
                return '';
            }
        },
        // 外层框的样式，在传入的这个类名中设置文字显示的宽度
        className: {
            type: String,
            default: () => {
                return '';
            }
        },
        // 为页面文字标识（如在同一页面中调用多次组件，此参数不可重复）
        id: {
            type: String,
            default: () => {
                return '';
            }
        },
        openDelay: {
            type: Number,
            default: () => {
                return 300;
            }
        },
        placement: {
            type: String,
            default: 'top-start'
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            hiddenTooltip: false
        };
    },
    methods: {
        onMouseOver(str) {
            const parentWidth = this.$refs[str].parentNode.offsetWidth;
            const contentWidth = this.$refs[str].offsetWidth;
            // 判断是否开启tooltip功能
            if(contentWidth > parentWidth) {
                this.hiddenTooltip = false;
            }else {
                this.hiddenTooltip = true;
            }
        }
    },
    watch: {
        content: {
            handler(val) {
                this.hiddenTooltip = (typeof val === 'string' && val.length > 0);
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
.over-flow {
    position: relative;
    margin: 0!important;
    line-height: 1;
    overflow: hidden;//
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
